import useCustomPageTitle from '@platform-ui-common/hooks/useCustomPageTitle.js';
import cx from 'classnames';
import { FormEvent, ReactNode, useCallback } from 'react';
import Typography from '../Typography/index.js';
import styles from './FormContainer.module.css';

interface FormContainerProps {
  children: ReactNode;
  buttons?: ReactNode;
  onSubmit?: () => void;
  title?: string;
  applyMinHeight?: boolean;
  // biome-ignore lint/suspicious/noExplicitAny: reason
  errors?: Record<string, any>;
  noValidate?: boolean;
  chip?: ReactNode;
}

export default function FormContainer({
  children,
  buttons,
  onSubmit,
  title,
  chip,
  applyMinHeight = true,
  noValidate = true,
}: FormContainerProps): JSX.Element {
  const onSubmitPreventDefault = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onSubmit();
    },
    [onSubmit],
  );
  useCustomPageTitle(title);

  return (
    <form
      className={cx('relative w-full lg:h-full flex-grow flex flex-col items-center')}
      onSubmit={onSubmitPreventDefault}
      noValidate={noValidate}
    >
      {chip && <div className="pb-4">{chip}</div>}
      {title && (
        <div className="max-w-[56rem]">
          <Typography id="form-page-title" variant="h1" alignment="center">
            {title}
          </Typography>
        </div>
      )}
      <div
        className={cx(
          'w-full mt-8 grow lg:grow-0 flex flex-col items-center gap-y-4',
          {
            'pb-10': !!buttons,
            'lg:min-h-[14.5rem]': applyMinHeight,
          },
          styles.formContainer,
        )}
        aria-live="polite"
      >
        {children}
      </div>
      {buttons}
    </form>
  );
}
